import { render, staticRenderFns } from "./PODs.vue?vue&type=template&id=ad0c3b4e&scoped=true"
import script from "./PODs.vue?vue&type=script&lang=js"
export * from "./PODs.vue?vue&type=script&lang=js"
import style0 from "./PODs.vue?vue&type=style&index=0&id=ad0c3b4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad0c3b4e",
  null
  
)

export default component.exports